const darkElements = 'hsl(209, 23%, 22%)';
const darkText = 'hsl(0, 0%, 100%)';
const darkBackground = 'hsl(207, 26%, 17%)';
const lightElements = 'hsl(0, 0%, 98%)';
const lightHeader = 'hsl(0, 0%, 98%)';
const lightText = 'hsl(200, 15%, 8%)';
const lightBackground = 'hsl(0, 0%, 98%)';
const lightInput = 'hsl(0, 0%, 52%)';

export const lightTheme = {
    header: lightHeader,
    body: lightBackground,
    text: lightText,
    element: lightElements,
    Input : lightInput,
};

export const darkTheme = {
    header: darkElements,
    body: darkBackground,
    text: darkText,
    element: darkElements,
};